import { render, staticRenderFns } from "./TaskRecommendationsForm.vue?vue&type=template&id=08fd13cd&lang=pug"
import script from "./TaskRecommendationsForm.vue?vue&type=script&lang=js"
export * from "./TaskRecommendationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports